module.exports = __webpack_public_path__ + "img/ready-to-scan-2.63e7b6ff.png";